import React from 'react'
import PropTypes from 'prop-types'
import ModalWizard from 'components/modal_wizard'
import { withRouter } from 'react-router'
import { routerShape } from 'react-router/lib/PropTypes'

import { exitGlimpse, isForward } from 'lib/glimpse'

class SendGlimpse extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    onUnmount: PropTypes.func,
    showSpinner: PropTypes.bool,
    children: PropTypes.any,
    routes: PropTypes.array.isRequired,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    router: routerShape.isRequired,
    campaignId: PropTypes.string,
    isOwner: PropTypes.bool,
    inSuccess: PropTypes.bool,
    isReturningFromWallet: PropTypes.bool,
  }

  handleClose = () => {
    const { router, isReturningFromWallet, campaignId } = this.props
    if (isReturningFromWallet) {
      router.push({ pathname: `/pools/c/${campaignId}` })
    } else {
      exitGlimpse('send', this.props.router)
    }
  }

  componentWillUnmount() {
    if (this.props.onUnmount) {
      this.props.onUnmount()
    }
  }

  render() {
    const child = React.Children.only(this.props.children)
    const stepName = this.props.routes[this.props.routes.length - 1].path

    return (
      <ModalWizard
        movingForward={isForward(this.props.location)}
        glimpse={true}
        hideBack={this.props.inSuccess || stepName === 'nochipin'}
        showSpinner={this.props.showSpinner}
        onClose={this.handleClose}
      >
        {React.cloneElement(child, { key: stepName })}
      </ModalWizard>
    )
  }
}

export default withRouter(SendGlimpse)
